<template>
    <div class="w100 serveEvaluate" style="background: #F2F3F6">
        <div class="mc" style="width: 1000px" v-loading="loading">
            <div  class="area-title pt10 pb10 pl5">
                办事指南评价
            </div>
            <div class="bg-w  pb20" style="position: relative">
                <div style="position: absolute;top: 30px;right: 20px" >
                    <div class="myl">满意率  {{evaluateSmallVo.rnkRate}}</div>
                </div>
            <div  class="area bg-w">

                <div class="area-info cl-f">
                    <div class="area-info-left fl">
                        <div class="area-info-left-name" v-text="evaluateSmallVo.serveName||''">
                        </div>
                        <div class="area-info-left-dept" >
                            <span>所属部门:</span><span v-text="evaluateSmallVo.deptName||''"></span>
                        </div>
                    </div>


                </div>
                <div class="area-satisfaction cl-f">
                    <div class="area-satisfaction-left fl">
                        <div class="area-satisfaction-left-item" v-for="(item,index) in satisfactionVoList">
                            <img class="w100" style="width: 20px;vertical-align:top;margin-right: 3px"
                                 :src="`${baseUrl}images/face${item.ix}.png`">{{item.rnkTitle+' '+(item.rnkRate||'')}}
                        </div>

                    </div>

                </div>
                <el-button type="primary"  @click="goEvaluateShow" round>
                    <i class="el-icon-edit-outline"></i>

                    我要评价</el-button>
            </div>
            </div>
        <div class=" bg-w"  style="margin-top: 10px;min-height: 500px" >
            <div  class="area">

                <div class="area-tab">

                    <div class="area-tab-top">
                        <div class="area-tab-top-item" v-if="satisfactionVoList.length"
                             :class="{ 'active-tab':curTabVal==0}"
                             @click="swtichTab(0)">
                            全部 ({{rnkCntTotal}})
                        </div>
                        <div v-else class="no-data">暂无评价记录。</div>
                        <div class="area-tab-top-item"
                             v-for="item in satisfactionVoList"
                             :class="{ 'active-tab':curTabVal==item.ix}"
                             @click="swtichTab(item.ix)">
                            {{item.rnkTitle+' ('+item.rnkCnt+')'}}
                        </div>

                    </div>
                </div>
                <div class="area-rate">
                    <div class="area-rate-tab" v-show="curTabVal==0">
                        <div class="area-rate-tab-item cl-f" v-for="item in satisfactionVoList">
                            <div class="area-rate-tab-item-left" v-text="item.rnkTitle">
                            </div>
                            <div class="area-rate-tab-item-center" >
                                <div :style="{ width: (item.rnkRate||'100%') }">
                                    <span v-text="item.rnkCnt+'次'"></span>
                                    <!-- <div :style="`background: url(${baseUrl}images/barBack.png)`"></div> -->
                                    <div class="area-rate-tab-item-center-bar"></div>
                                </div>
                            </div>
                            <div class="area-rate-tab-item-right" v-text="item.rnkRate">
                            </div>
                        </div>
                    </div>
                    <div class="area-rate-tab" v-for="pro in satisfactionVoList" v-show="curTabVal==pro.ix">
                        <div class="area-rate-tab-item cl-f" v-for="item in (pro.opnionList||[])">
                            <div class="area-rate-tab-item-left" v-text="item.opnionName">
                            </div>
                            <div class="area-rate-tab-item-center" >
                                <div  :style="{ width: (item.opnionRate||'100%') }">
                                    <span v-text="item.opnionCnt+'次'"></span>
                                    <!-- <div :style="`background: url(${baseUrl}images/barBack.png)`"></div> -->
                                    <div class="area-rate-tab-item-center-bar"></div>
                                </div>
                            </div>
                            <div class="area-rate-tab-item-right" v-text="item.opnionRate">
                            </div>
                        </div>
                    </div>

                </div>
                <div class="detail-box" v-loading="commentLoading">
                    <p class="pb20" style="
                                            font-size: 20px;
                                            font-family: Source Han Sans SC;
                                            font-weight: 500;
                                            color: #333333;">评价详情</p>
                    <div class="detail-item flex-box" v-for="(item, index) in commentList" :key="index">
                        <div class="detail-avatar">
                            <img :src="item.avatar" alt="" v-if="item.userAvatar">
                            <img :src="`${baseUrl}images/avatar.png`" alt="" v-else>
                        </div>
                        <div class="detail-content flex-1">
                            <div class="top-item flex-box">
                                <div class="mr20">{{item.privateFlag == 1?item.userName:'***'}}</div>
                                <div>
                                    <el-rate :value="Number(item.serrRations)" disabled></el-rate>
                                </div>
                            </div>
                            <div class="bottom-item">{{item.serrContent}}
                                <span v-if="item.serrAttach"  @click="openAttach(item.serrAttach)">点击查看附件</span></div>
                        </div>
                        <div class="time">{{item.serrTime}}</div>
                    </div>
                    <div v-if="commentList.length==0" class="no-data">无数据。</div>
                    <div class="pagination" v-if="commentList.length">
                        <el-pagination background @size-change="changeSize"
                                       @current-change="changePage"
                                       :current-page="paramSearch.current"
                                       :page-size="paramSearch.size"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="paramSearch.total"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <evaluateDialog ref="evaluateDialog" @saveSuccess="saveSuccess"></evaluateDialog>
    </div>
</template>

<script>
    import {
        serveEvaluateBigVoList,
        serveEvaluateSmallVo,
        serveEvaluateTypeVoList,
        serveSatisfactionVoList
    } from '@/api/serveCenter/serveCenter';
    import evaluateDialog from "@/views/serveCenter/evaluateDialog";
    export default {
        name: "serveEvaluate",
        components: {evaluateDialog},
        props: [],
        data() {

            return {
                baseUrl: process.env.BASE_URL,
                serveId:"",
                loading:false,
                commentLoading:false,
                curTabVal:0,
                paramSearch:{
                    current:1,
                    ix:0,
                    size:10,
                    total:0,
                    serve_id:''
                },
                commentList:[],
                satisfactionVoList:[],
                evaluateSmallVo:{}

            };
        },
        computed: {
            rnkCntTotal(){
                let total=0;
                this.satisfactionVoList.forEach(i=>{
                    total+=Number(i.rnkCnt)
                })

                return total;
            }
        },
        created() {},
        mounted() {
            this.serveId=this.$route.query.id;
            this.paramSearch.serve_id=this.serveId;
            this.getServeEvaluateBigVoList();
            this.getServeEvaluateSmallVo();
            // this.getServeEvaluateTypeVoList();
            this.getServeSatisfactionVoList();
        },
        methods: {
            openAttach(url){
                window.open(url);
            },
            saveSuccess(){
                this.getServeEvaluateBigVoList();
                this.getServeEvaluateSmallVo();
                this.getServeSatisfactionVoList();
            },
            swtichTab(val){
                this.curTabVal =val;
                this.paramSearch.ix=val;
                this.paramSearch.current=1;
                this.getServeEvaluateBigVoList();

            },

            goEvaluateShow(){
                this.$refs.evaluateDialog.dialogShow(this.serveId)
            },


            getServeSatisfactionVoList () {
                serveSatisfactionVoList({serve_id:this.serveId}).then(({data})=> {
                    if(data.code == 0){
                        this.satisfactionVoList=data.data||[]


                    }
                }).catch(() => {

                });
            },
            // 获取评价查询列表
            getServeEvaluateTypeVoList () {

                serveEvaluateTypeVoList({score:'2'}).then(({data})=> {

                    if(data.code == 0){

                    }
                }).catch(() => {

                });
            },
            // 获取评价查询列表
            getServeEvaluateSmallVo () {

                serveEvaluateSmallVo(this.paramSearch).then(({data})=> {

                    if(data.code == 0){
                        this.evaluateSmallVo=data.data||{}

                    }
                }).catch(() => {

                });
            },
            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getServeEvaluateBigVoList();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getServeEvaluateBigVoList();
            },

            // 获取评价查询列表
            getServeEvaluateBigVoList () {
                this.commentLoading = true;
                serveEvaluateBigVoList(this.paramSearch).then(({data})=> {
                    this.commentLoading = false;
                    if(data.code == 0){
                        this.commentList = data.data.records || []
                        this.paramSearch.total = data.data.total;
                    }
                }).catch(() => {
                    this.commentLoading = false;
                });
            },

        },
        destroyed() {

        },
        watch: {

        },
        filters: {},
    };
</script>

<style scoped lang="less" >
    .area{
        width: 860px;
        margin: 0 auto;
        padding: 10px 0;
        &-title{
            font-size: 24px;
            color: #000;
            padding-bottom: 10px;
            font-weight: 700;

        }
        &-info{
            padding: 20px 0;
            &-left{

                &-name{
                    font-weight: 700;
                    color: #666;
                    font-size: 22px;
                }
                &-dept{
                    padding-top: 10px;
                    color: #ccc;
                    font-size: 14px!important;
                }

            }

        }
        &-satisfaction{
            padding-bottom: 20px;
            &-left{
                &-item{
                    display: inline-block;
                    padding-right: 20px;
                }
            }

        }
        &-tab{
            padding: 20px 0;
            &-top{
                &-item{
                    display: inline-block;
                    padding:10px 12px;
                    min-width: 100px;
                    border-radius: 3px;
                    text-align: center;
                    margin-right: 35px;
                    background: #F2F2F2;
                    cursor:pointer;
                    &.active-tab{
                        // background: #409EFF;
                        color: #fff;
                        cursor:text;
                        position: relative;
                        // &:after {
                        //     content: '';
                        //     display: block;
                        //     width: 0;
                        //     height: 0;
                        //     border: 8px solid transparent;
                        //     position: absolute;
                        //     bottom: -14px;
                        //     z-index: 0;
                        //     border-top: 8px solid #409EFF;
                        //     right: 54px;
                        // }
                    }
                }
            }

        }
        &-rate{
            padding-top: 20px;
            &-tab{
                width: 100%;
                &-item{
                    width: 100%;
                    padding: 10px 0;
                    >div{
                        float: left;
                        height:20px;
                        line-height: 20px;
                    }
                    &-left{
                        width: 120px;

                    }
                    &-right{
                        width: 60px;
                        padding-left: 5px;
                    }
                    &-center{
                        width:  678px;
                        background: #F2F3F5;
                        >div{
                            text-align: center;
                            color: #fff;
                            line-height: 20px;
                            height: 20px;
                            overflow: hidden;
                            position: relative;
                            >span{
                                position: absolute;
                                left: 50%;

                            }
                            >div{
                                height: 20px;
                                width: 678px;
                                background-size:100%!important;
                            }
                        }
                    }
                }
            }
        }
        .detail-box {
            /*box-shadow: 1px 4px 15px 0px #E5E6E7;*/
            /*border-radius: 6px;*/
            margin: 30px 0;
            .detail-item:not(:last-child){
                border-bottom: 1px solid #EBEBEB;
            }
            .detail-item {
                min-height: 98px;
                padding: 20px 0;
                .detail-avatar {
                    height: 46px;
                    width: 46px;
                    margin-right: 16px;
                    img {
                        height: 100%;
                        width: 100%;
                        border-radius: 100%;
                    }
                }
                .time {
                    width: 120px;
                    font-size: 12px;
                    text-align: center;
                    color: #666666;
                }
                .detail-content {
                    .top-item {
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        font-size: 14px;
                    }
                    .bottom-item {
                        word-break:break-all;
                        color: #333333;
                        font-size: 12px;
                        >span{
                            color: #2cacf0;
                            cursor: pointer;
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

    }

</style>
